import { createFileRoute, useParams } from "@tanstack/react-router";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { OvertimeApprovalDetailPage } from "@/components/supervisor/overtime/OvertimeApprovalDetailPage";
import { requireFeature, requireSetting } from "@/lib/feature-gate";

export const Route = createFileRoute(
  "/supervisor/_layout/overtime-requests_/$id",
)({
  beforeLoad: () => {
    requireFeature("attendance");
    requireSetting("overtime_approval_required");
  },
  component: AllOvertimeRequestsDetail,
});

function AllOvertimeRequestsDetail() {
  const { id } = useParams({
    from: "/supervisor/_layout/overtime-requests_/$id",
  });
  return (
    <SidebarInset>
      <DashboardHeader current={"Overtime Detail"}
      />
      <div className="flex flex-col gap-4 p-6 pt-0">
        <OvertimeApprovalDetailPage approvalId={id} />
      </div>
    </SidebarInset>
  );
}
